//  导入插件 - 移除自定义按钮，它们不是插件
const buttonPlugins = 'emoticons preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media code codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern autosave '

// 导入工具栏 - 格式刷在前面，首行缩进放到两端对齐后面
const toolbar = 'formatpainter | fullscreen undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link anchor | table image media wordpaster | alignleft aligncenter alignright alignjustify indent2em outdent indent | formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | charmap emoticons hr pagebreak insertdatetime print preview | code selectall searchreplace visualblocks | lineheight axupimgs wechatCleanup'

// 初始化配置
export const init = {
  //readonly: false, //只读模式
  // auto_focus: true,//自动聚焦
  relative_urls : false,
  convert_urls: false,//url如图片地址使用绝对路径
  draggable_modal: true,//模态窗口允许拖动
  inline: false,//内联模式
  cleanup: true,
  language_url: 'static/tinymce/langs/zh_CN.js', // 引入语言包文件
  language: 'zh_CN', // 语言类型
  // content_css: true,
  skin_url: 'static/tinymce/skins/ui/oxide', // 皮肤：浅色
  // skin_url: 'static/tinymce/skins/ui/oxide-dark',//皮肤：暗色

  plugins: buttonPlugins, // 插件配置
  toolbar: toolbar, // 工具栏配置，设为false则隐藏

  // menubar: false, // 菜单栏配置，设为false则隐藏，不配置则默认显示全部菜单，也可自定义配置--查看 http://tinymce.ax-z.cn/configure/editor-appearance.php --搜索“自定义菜单”
  emoticons_database_url: 'tinymce/plugins/emoticons/js/emojis.js',
  fontsize_formats: '12px 14px 16px 18px 20px 22px 24px 28px 32px 36px 48px 56px 72px', // 字体大小
  font_formats: '微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;', // 字体样式 微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif, 宋体=simsun,serif,仿宋体=FangSong,黑体=SimHei,Arial=arial,
  lineheight_formats: '0.5 0.8 1 1.2 1.5 1.75 2 2.5 3 4 5', // 行高配置，也可配置成"12px 14px 16px 20px"这种形式
  branding: false, // tiny技术支持信息是否显示
  resize: 'both', // 编辑器宽高是否可变，false-否,true-高可变，'both'-宽高均可，注意引号
  // statusbar: false,  //最下方的元素路径和字数统计那一栏是否显示
  elementpath: false, // 元素路径是否显示
  min_height: 400, // 最小高度
  max_height: 800, // 最大高度

  // 改善内容样式，增加字体大小和行高
  content_style: `
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
      font-size: 16px;
      line-height: 1.6;
      color: #333;
      padding: 20px;
      max-width: none;
    }
    p {
      margin: 0 0 12px 0;
      font-size: 16px;
      line-height: 1.6;
    }
    h1, h2, h3, h4, h5, h6 {
      margin: 20px 0 12px 0;
      line-height: 1.4;
    }
    img {
      max-width: 100%;
      height: auto;
    }
    table {
      border-collapse: collapse;
      width: 100%;
    }
    table td, table th {
      border: 1px solid #ddd;
      padding: 8px;
    }
  `,
  content_css: false,

  // 允许自定义元素和属性
  extended_valid_elements: 'p[id|class|style|data-*|contenteditable],button[type|class|style|data-*],strong[style],span[style],small[style],br',
  custom_elements: 'wechat-image-placeholder',
  verify_html: false, // 不验证HTML
  valid_children: '+p[button]', // 允许p元素包含button
  allow_unsafe_link_target: true,
  convert_urls: false, // 不转换URL

  // 自定义按钮设置已移动到TEditor组件中，避免setup函数冲突

  paste_data_images: true, // 图片是否可粘贴
  paste_as_text: false, // 默认不以纯文本粘贴
  paste_webkit_styles: 'color font-size font-family background-color', // 保留的样式
  paste_retain_style_properties: 'color font-size font-family background-color', // 保留的样式属性
  paste_remove_styles_if_webkit: false, // 不移除webkit样式
  paste_preprocess: function(plugin, args) {
    // 预处理粘贴内容，可以在这里处理微信图片
    console.log('粘贴预处理:', args.content);
  },
  images_upload_handler: (blobInfo, success, failure) => {
  // 需要在setup里面重新写,传入 url
  },
	file_picker_types: 'media',
	file_picker_callback: (cb,valute,meta) => {
		// 需要在setup里面重新写,传入 url
	},
	external_plugins: {
		powerpaste: '/static/tinymce/plugins/powerpaste/plugin.min.js',
		wordpaster: '/static/tinymce/plugins/wordpaster.js',
	},
	powerpaste_word_import: 'prompt', // 修正拼写错误
	powerpaste_html_import: 'prompt', // 修正拼写错误
	powerpaste_allow_local_images: true,
	// 添加更多粘贴相关配置
	paste_block_drop: false, // 允许拖拽
	paste_merge_formats: true, // 合并格式
	smart_paste: true, // 智能粘贴
}